import template   from './product-tile.html'
import controller from './product-tile.controller'
import './product-tile.styl'

let component = {
  restrict: 'E',
  bindings: {
    product: '<'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-tile/product-tile.component.js